import { Box, Grid, Stack, Card, Tab } from '@mui/material';
import { memo, useEffect, useState } from 'react';
import ImageDraggable from 'src/components/image/image-draggable';
import { CommonHelper } from 'src/utils/commonHelper';
import { useToaster } from 'src/utils/toaster/toasterContext';
import { NewPostStyledComponent } from './newPostStyled.component';
import PostDescription from './post-description.component';
import PostUploadComponent from './post-upload.component';
import ConnectedMediaComponent from './connected-media.component';
import PostAddIcon from '@mui/icons-material/PostAdd';
import ScheduleIcon from '@mui/icons-material/Schedule';
import ApprovalIcon from '@mui/icons-material/CheckCircle';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import MobileViewPostConditionComponent from './mobile-view-post-condition/post-condition.component';
import PostPreviewComponent from './post-preview.component';
import { ErrorOutline as ErrorOutlineIcon, Send as SendIcon, ScheduleSend as ScheduleSendIcon } from '@mui/icons-material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { LoadingButton } from "@mui/lab";
import { FormControlLabel, TextField, Typography, IconButton } from "@mui/material";
import { Popover, Select, ButtonGroup, Button, MenuItem, Menu, Divider } from "@mui/material";
import { LocalizationProvider, MobileDateTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { SVGComponent } from "src/components/svg/svg-component";
import useCollapseDrawer from "src/hooks/useCollapseDrawer";
import { useTheme, createTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Savedraft from '../../assets/icons/save-draft.svg';
import PostFirstComment from './post-first-comment.component';
import { integrateModuleURL } from 'src/services/urlService';
import { useNavigate } from 'react-router-dom';
import HttpServices from 'src/services/httpService';
import AIContentComponent from './ai/ai-content.component';
import PostBulkUploadComponent from './post-bulk-upload.component';
import { useTranslation } from 'react-i18next';

const MobileNewPostComponent = ({
    configuredSocialMedia,
    selectedSocialMedias,
    handleNetworks,
    handleAddAllDescription,
    handleAddAllCommentDescription,
    handleMediaFiles,
    newPostForm,
    updateRequestData,
    handleConditionErrors,
    googleMyBusinessConditionRef,
    tiktokConditionRef,
    linkedInConditionRef,
    youtubeConditionRef,
    twitterConditionRef,
    threadsConditionRef,
    instagramConditionRef,
    facebookConditionRef,
    pinterestConditionRef,
    blueskyConditionRef,
    snapchatConditionRef,
    previewRef,
    tabValue,
    setTabValue,
    isSubmittingDraft,
    handleSaveDraft,
    scheduleDateTime,
    handleScheduleDate,
    whenToPost,
    PostOption,
    handlePostTypeChange,
    handleFormsubmit,
    handleSelectPostTypeChange,
    hasApproverPermission,
    isSubmitting
}) => {
    const { showToast } = useToaster();
    const { t: translate } = useTranslation();
    const navigate = useNavigate();

    //State Variables
    useEffect(() => {
        handleUpdateNewFormData();
    }, [tabValue]);

    const [isUploadMediaPopupOpen, setUploadMediaPopup] = useState(false);
    const [isBulkMediaPopupOpen, setBulkMediaPopup] = useState(false);
    const [fileUploadprogress, setFileUploadprogress] = useState();
    const [height, setHeight] = useState(window.innerHeight - 200);
    const [showAIPopup, setAIPopup] = useState(false);
    const theme = useTheme();
    const customTheme = createTheme({
        breakpoints: {
            values: {
                mdCustom: 1100,
            },
        },
    });

    const isDesktop = useMediaQuery(customTheme.breakpoints.up('mdCustom'));
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleOptionSelect = (option) => {
        handleSelectPostTypeChange(option);
        handleMenuClose();
    };

    const handleUploadMediaPopup = (show = false) => {
        setUploadMediaPopup(show);
    };
    const handleBulkMediaPopup = (show = false) => {
        setBulkMediaPopup(show);
    };
    const handleUploadMedia = (files) => {
        let mFiles = [...newPostForm.media_data];
        mFiles = mFiles.concat(files);
        setUploadMediaPopup(false);
        handleMediaFiles(mFiles);
    };
    const privateFileUploadSuccessCallback = (data, message, uploadFiles = []) => {
        const mFiles = [...data?.media_datas, ...uploadFiles];
        message && showToast(message, 's');
        handleUploadMedia(mFiles);
        handleUploadMediaPopup(false);
    };

    const fileUploadSuccessCallback = (data, message, privateFiles) => {
        if (privateFiles.length > 0) {
            const uploadFilesProps = {
                privateFiles,
                successCallback: (privateData, message) => privateFileUploadSuccessCallback(privateData, message, data),
                failureCallback,
            };
            CommonHelper.UploadPrivateMediaFilesToServer({ ...uploadFilesProps });
        } else {
            message && showToast(message, 's');
            handleUploadMedia(data);
            handleUploadMediaPopup(false);
        }
    };

    const failureCallback = (message) => {
        showToast(message, 'e');
    };
    const handleUploadMediaToServer = (files, privateFiles) => {
        if (files.length == 0 && privateFiles.length > 0) {
            const uploadFilesProps = {
                privateFiles,
                successCallback: (data, message) => privateFileUploadSuccessCallback(data, message),
                failureCallback,
            };
            CommonHelper.UploadPrivateMediaFilesToServer({ ...uploadFilesProps });
        }
        else {
            let uploadFilesProps = {
                files,
                setFileUploadprogress,
                successCallback: (data, message) => { fileUploadSuccessCallback(data, message, privateFiles) },
                failureCallback,
            };
            CommonHelper.UploadMediaFilesToServer({ ...uploadFilesProps });
        }
    };
    const handleReOrderFiles = (oldIndex, newIndex) => {
        let files = newPostForm.media_data;
        let mediaFiles = CommonHelper.ReArrangeArray(files, oldIndex, newIndex);
        handleMediaFiles(mediaFiles);
    };
    const handleRemoveFiles = (mediaUrl) => {
        let files = [...newPostForm.media_data];
        let index = files.findIndex((a) => a.media_url === mediaUrl);
        if (index >= 0) files.splice(index, 1);
        handleMediaFiles(files);
    };

    const handleChangeTab = (event, newValue) => {
        setTabValue(newValue);
    };
    const handleUpdateNewFormData = () => {
        let newFormData = { ...newPostForm };
        let facebookRequestData = newFormData.scheduled_event_requests_data.facebook_requests_data;
        let instagramRequestData = newFormData.scheduled_event_requests_data.instagram_requests_data;
        let youtubeRequestData = newFormData.scheduled_event_requests_data.youtube_requests_data;
        let twitterRequestData = newFormData.scheduled_event_requests_data.twitter_requests_data;
        let linkedinRequestData = newFormData.scheduled_event_requests_data.linkedin_requests_data;
        let gbusinessRequestData = newFormData.scheduled_event_requests_data.gbusiness_requests_data;
        let pinterestRequestData = newFormData.scheduled_event_requests_data.pinterest_requests_data;
        let threadsRequestData = newFormData.scheduled_event_requests_data.threads_requests_data;
        let blueskyRequestData = newFormData.scheduled_event_requests_data.bluesky_requests_data;
        let snapchatRequestData = newFormData.scheduled_event_requests_data.snapchat_requests_data;

        if (facebookRequestData?.length > 0) {
            if (facebookConditionRef && facebookConditionRef.current) {
                facebookConditionRef.current.handleRequestData(facebookRequestData);
            }
        }
        if (instagramRequestData?.length > 0) {
            if (instagramConditionRef && instagramConditionRef.current) {
                instagramConditionRef.current.handleRequestData(instagramRequestData);
            }
        }
        if (youtubeRequestData?.length > 0) {
            if (youtubeConditionRef && youtubeConditionRef.current) {
                youtubeConditionRef.current.handleRequestData(youtubeRequestData);
            }
        }
        if (twitterRequestData?.length > 0) {
            if (twitterConditionRef && twitterConditionRef.current) {
                twitterConditionRef.current.handleRequestData(twitterRequestData);
            }
        }
        if (linkedinRequestData?.length > 0) {
            if (linkedInConditionRef && linkedInConditionRef.current) {
                linkedInConditionRef.current.handleRequestData(linkedinRequestData);
            }
        }
        if (gbusinessRequestData?.length > 0) {
            if (googleMyBusinessConditionRef && googleMyBusinessConditionRef.current) {
                googleMyBusinessConditionRef.current.handleRequestData(gbusinessRequestData);
            }
        }
        if (pinterestRequestData?.length > 0) {
            if (pinterestConditionRef && pinterestConditionRef.current) {
                pinterestConditionRef.current.handleRequestData(pinterestRequestData);
            }
        }
        if (threadsRequestData?.length > 0) {
            if (threadsConditionRef && threadsConditionRef.current) {
                 threadsConditionRef.current.handleRequestData(pinterestRequestData);
            }
        }
        if (blueskyRequestData?.length > 0) {
            if (blueskyConditionRef && blueskyConditionRef.current) {
                blueskyConditionRef.current.handleRequestData(blueskyRequestData);
            }
        }
        if (snapchatRequestData?.length > 0) {
            if (pinterestConditionRef && snapchatConditionRef.current) {
                snapchatConditionRef.current.handleRequestData(snapchatRequestData);
            }
        }

        //Preview Ref
        if (previewRef && previewRef.current) {
            let fData = JSON.parse(JSON.stringify(newFormData));
            previewRef.current.handlePreviewData(fData);
        }
    };

    const submitButtonView = () => {
        switch (whenToPost) {
            case PostOption.PostNow.Name:
                return <SendIcon style={{ color: theme.palette.primary.main }} />;
            case PostOption.SchedulePost.Name:
                return <ScheduleIcon style={{ color: theme.palette.primary.main }} />;
            case PostOption.ApprovalPost.Name:
                return <ApprovalIcon style={{ color: theme.palette.primary.main }} />;
            default:
                return null;  // Optionally return a default icon or null
        }
    };

    const handleAIContent = () => {
        checkAIEnabledForThisBrand();
    };

    const aiEnabledSuccesscallback = (data, message) => {
        if (data) {
            setAIPopup(true);
        } else {
            showToast("Ensure your OpenAI API key is configured in the 'Manage Brand' or 'Manage Organization' section to start using AI-generated content.", 's');
            navigate('/manage-brand');
        }
    };

    const checkAIEnabledForThisBrand = () => {
        let postProps = {
            url: integrateModuleURL.checkAIEnabledForThisBrand,
            body: null,
            successCallback: aiEnabledSuccesscallback,
            failureCallback,
        };
        HttpServices.Post(postProps);
    };

    const handleUseAIContent = (content) => {
        handleAddAllDescription(content.trim());
        setAIPopup(false);
    }

    const handleCloseAIPopup = () => {
        setAIPopup(false);
    }


    return (
        <>
            <Box sx={{ boxShadow: 'none', height: 'calc(100vh - 175px)', overflow: 'auto', background: 'white', p: 1, pt: 2 }}>
                <Grid container>
                    <Grid item xs={12} alignItems="center">
                        <Stack direction="row" justifyContent="space-between" spacing={2}>
                            <NewPostStyledComponent.LabelStyle>{translate('mobile_new_post.profile', 'Profile')}</NewPostStyledComponent.LabelStyle>
                        </Stack>
                    </Grid>
                    <Grid item xs={12}>
                        <ConnectedMediaComponent
                            configuredSocialMedia={configuredSocialMedia}
                            selectedSocialMedias={selectedSocialMedias}
                            handleNetworks={handleNetworks}
                        />
                    </Grid>
                </Grid>
                <PostDescription
                    handleChangeDescription={handleAddAllDescription}
                    valueDescription={newPostForm.description}
                    handleUploadMediaPopup={handleUploadMediaPopup}
                    handleBulkMediaPopup={handleBulkMediaPopup}
                    showInputProps={true}
                    handleAIContent={handleAIContent}
                />
                {newPostForm.media_data?.length > 0 && (
                    <Box>
                        <ImageDraggable
                            mediaFiles={newPostForm.media_data}
                            handleRemoveFiles={handleRemoveFiles}
                            handleReOrderFiles={handleReOrderFiles}
                        />
                    </Box>
                )}
                <PostFirstComment showInputProps={true} handleChangeDescription={handleAddAllCommentDescription} valueDescription={newPostForm.comment_description} />
                <TabContext value={tabValue}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
                        <TabList onChange={handleChangeTab}>
                            <Tab iconPosition="start" label={translate('mobile_new_post.conditions', 'Conditions')} value={1} />
                            <Tab iconPosition="start" label={translate('mobile_new_post.preview', 'Preview')} value={2} />
                        </TabList>
                    </Box>
                    <TabPanel value={1} sx={{ padding: 0, paddingTop: 2 }}>
                        <MobileViewPostConditionComponent
                            updateRequestData={updateRequestData}
                            handleConditionErrors={handleConditionErrors}
                            googleMyBusinessConditionRef={googleMyBusinessConditionRef}
                            tiktokConditionRef={tiktokConditionRef}
                            linkedInConditionRef={linkedInConditionRef}
                            youtubeConditionRef={youtubeConditionRef}
                            twitterConditionRef={twitterConditionRef}
                            instagramConditionRef={instagramConditionRef}
                            facebookConditionRef={facebookConditionRef}
                            pinterestConditionRef={pinterestConditionRef}
                            threadsConditionRef={threadsConditionRef}
                            blueskyConditionRef={blueskyConditionRef}
                            snapchatConditionRef={snapchatConditionRef}
                        />
                    </TabPanel>
                    <TabPanel value={2} sx={{ padding: 0, paddingTop: 2 }}>
                        <PostPreviewComponent ref={previewRef} />
                    </TabPanel>
                </TabContext>
                <Box style={{ width: '100%', marginTop: '0.8rem', marginBottom: '0.3rem' }} >
                    <Stack display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" sx={{ height: '3rem' }}>
                        <IconButton
                            onClick={handleSaveDraft}
                        >
                            <img src={Savedraft} alt="Savedraft_Icon"
                                width={25}
                                height={25} />
                        </IconButton>
                        <Stack display="flex" flexDirection="row" style={{ alignItems: 'center' }}>
                            {whenToPost !== PostOption.PostNow.Name && (
                                <LocalizationProvider dateAdapter={AdapterDayjs} size="small" sx={{ pb: 2 }}>
                                    <MobileDateTimePicker
                                        placeholder={translate('common.select_time', 'Select Time')}
                                        value={dayjs(scheduleDateTime)}
                                        onChange={handleScheduleDate}
                                        disabled={whenToPost === PostOption.PostNow.Name}
                                        minDateTime={dayjs()}
                                        renderInput={(props) => <TextField {...props} size="small"
                                        />}
                                    />
                                </LocalizationProvider>
                            )}
                            {/* <FormControlLabel
                                control={
                                    <NewPostStyledComponent.SwitchStyle
                                        sx={{ mr: whenToPost !== PostOption.SchedulePost.Name && 1, ml: 2 }}
                                        size="small"
                                        checked={whenToPost === PostOption.SchedulePost.Name}
                                        onChange={handlePostTypeChange}
                                    />
                                }
                                label={whenToPost !== PostOption.SchedulePost.Name && <Typography variant="body1" color="black">Is Scheduled Post</Typography>}
                            />
                            <IconButton
                                onClick={handleFormsubmit}
                            >{whenToPost === PostOption.SchedulePost.Name ? <ScheduleSendIcon style={{ color: theme.palette.primary.main }} /> : <SendIcon style={{ color: theme.palette.primary.main }} />}

                            </IconButton> */}
                            <ButtonGroup variant="contained" aria-label="Button group with a nested menu" sx={{ ml: 1 }}>
                                <IconButton
                                    onClick={handleFormsubmit}
                                >
                                    {submitButtonView()}
                                </IconButton>
                                <Divider
                                    orientation="vertical"
                                    flexItem
                                />
                                <Button
                                    onClick={handleMenuClick}
                                    size="small"
                                    aria-label="select merge strategy"
                                    aria-haspopup="menu"
                                >
                                    <ArrowDropDownIcon />
                                </Button>
                                <Popover
                                    anchorEl={anchorEl}
                                    open={Boolean(anchorEl)}
                                    onClose={handleMenuClose}
                                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                                    transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                                    PaperProps={{
                                        sx: {
                                            p: 1,
                                            width: 'auto',
                                            boxShadow: 3,
                                            borderRadius: 2,
                                            backdropFilter: 'blur(8px)',
                                            backgroundColor: 'action.disabledOpacity',
                                            boxShadow: '0px 4px 30px rgba(0, 0, 0, 0.1)',
                                            '& .MuiMenuItem-root': {
                                                px: 2.5,
                                                py: 1.5,
                                                typography: 'body2',
                                                borderRadius: 2,
                                                transition: 'background-color 0.2s, transform 0.2s',
                                                display: 'flex',
                                                alignItems: 'center',
                                                '&:hover': {
                                                    backgroundColor: 'action.disabledOpacity',
                                                    transform: 'scale(1.02)',
                                                },
                                                '& .MuiSvgIcon-root': {
                                                    fontSize: '1.5rem',
                                                    marginRight: 2,
                                                },
                                                '& .MuiTypography-root': {
                                                    fontWeight: 500,
                                                },
                                            },
                                        },
                                    }}
                                >

                                    <MenuItem
                                        disabled={!hasApproverPermission}
                                        value={PostOption.PostNow.Name}
                                        onClick={() => handleOptionSelect(PostOption.PostNow.Name)}
                                    >
                                        <PostAddIcon />
                                        {PostOption.PostNow.Label}
                                    </MenuItem>
                                    <MenuItem
                                        disabled={!hasApproverPermission}
                                        value={PostOption.SchedulePost.Name}
                                        onClick={() => handleOptionSelect(PostOption.SchedulePost.Name)}
                                    >
                                        <ScheduleIcon />
                                        {PostOption.SchedulePost.Label}
                                    </MenuItem>
                                    <MenuItem
                                        value={PostOption.ApprovalPost.Name}
                                        onClick={() => handleOptionSelect(PostOption.ApprovalPost.Name)}
                                    >
                                        <ApprovalIcon />
                                        {PostOption.ApprovalPost.Label}
                                    </MenuItem>

                                </Popover>
                            </ButtonGroup>
                        </Stack>
                    </Stack>
                </Box>
            </Box>
            {/* Popup Place */}
            {isUploadMediaPopupOpen && (
                <PostUploadComponent handleClose={handleUploadMediaPopup} fileUploadprogress={fileUploadprogress} handleUpload={handleUploadMediaToServer} />
            )}
            {isBulkMediaPopupOpen && (
                <PostBulkUploadComponent handleClose={handleBulkMediaPopup} />
            )}
            {showAIPopup && <AIContentComponent handleUseAIContent={handleUseAIContent} handleClose={handleCloseAIPopup} />}
        </>
    );
};
export default MobileNewPostComponent;